import { Grid, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React, { useContext, useState } from "react";
import { userJourneyContext } from "../../states/context/userJourneyContext";
import { getProgress, updateUserJourneyState } from "./mockUtils";

const MockDialogBox = ({ mockModalData, image, callback }) => {
  const userContext = useContext(userJourneyContext);
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  const getStarted = () => {
    setOpen(false);
    if (callback) {
      callback();
    }

    (async () => {
      try {
        userContext.setUserJourneyProgress(
          getProgress(userContext.userJourneyInfo)
        );
        userContext.setUserJourneyInfo(
          updateUserJourneyState(userContext.userJourneyInfo)
        );
      } catch (e) {
        console.log(e);
      }
    })();
  };

  return (
    <div>
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={open}
        BackdropProps={{
          classes: {
            root: classes.backDrop,
          },
        }}
      >
        <Grid
          container
          className={
            mockModalData.description
              ? classes.modalRoot
              : classes.modalRootKeyPointersStyle
          }
        >
          <Grid item xs={12} >
            <img
              src={image}
              style={{
                width: '100%',
                height: "192px",
              }}
              alt={"KAVIDA"}
              loading="lazy"
            />
          </Grid>
          <Grid item xs={12} className={classes.descriptionContainerStyle}>
            <Typography id="modal-title" className={classes.titleStyle}>
              {mockModalData.title}
            </Typography>
            <div className={classes.descriptionStyle}>
              {mockModalData.description ? (
                <p style={{whiteSpace: "pre"}} id="modal-description">{mockModalData.description}</p>
              ) : (
                <>
                  {mockModalData.keyPoints?.map((p, i) => (
                    <p key={i} className={classes.descriptionContentStyle}>
                      {i + 1}. {p}
                    </p>
                  ))}
                </>
              )}
            </div>
          </Grid>
          <Grid item xs={12} className={classes.buttonContainerStyle}>
            <Button
              className={classes.buttonStyle}
              variant="contained"
              onClick={() => getStarted()}
            >
              {mockModalData.buttonLabel}
            </Button>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
};

export default MockDialogBox;

const useStyles = makeStyles((theme) => ({
  modalRoot: {
    width: "440px",
    height: 'auto',
    overflow: 'hidden',
    "& .MuiButton-root": {
      backgroundColor: "#3B82F6",
      color: "white",
      textTransform: "none",
      borderRadius: "2px",
    },
  },
  modalRootKeyPointersStyle: {
    width: "440px",
    height: "auto",
    "& .MuiButton-root": {
      backgroundColor: "#3B82F6",
      color: "white",
      textTransform: "none",
      borderRadius: "2px",
    },
  },
  descriptionContainerStyle: {
    padding: "24px",
  },
  titleStyle: {
    fontFamily: "Inter",
    fontWeight: 700,
    fontSize: "18px",
    lineHeight: "28px",
  },
  descriptionStyle: {
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#64748B",
  },
  descriptionContentStyle: {
    margin: "0px",
  },
  buttonStyle: {
    margin: "24px",
  },
  buttonContainerStyle: {
    backgroundColor: "#F8FAFC",
  },
  backDrop: {
    backdropFilter: "blur(8px)",
    backgroundColor: "rgba(255,255,255,0.01)",
  },
}));
